<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import type { CommunicatieFeaturesBerichtenVoorwaardeDto as Voorwaarde } from '@services/communicatie-public/orval-api/model/communicatieFeaturesBerichtenVoorwaardeDto';
import VCallToAction from '@shared/component/VCallToAction/VCallToAction.vue';
import VSkeleton from '@shared/component/VSkeleton/VSkeleton.vue';

export interface VVoorwaardenProps {
  loading?: boolean;
  voorwaarden?: Voorwaarde[];
}

const props = defineProps<VVoorwaardenProps>();
</script>

<template>
  <template v-if="props.loading">
    <div class="space-y-3">
      <VSkeleton class="max-w-sm" :timeout="0" />

      <div class="grid grid-cols-[auto_auto] gap-x-8 gap-y-3">
        <VSkeleton v-for="i in 4" :key="i" :timeout="0" />
      </div>
    </div>
  </template>

  <div v-else-if="!props.voorwaarden?.length">
    <VCallToAction
      :icon="['fal', 'wind']"
      title="Het is via deze pagina niet mogelijk om voorwaarden uit het verleden in te zien"
    />
  </div>

  <div v-else class="grid grid-cols-[auto_auto] gap-x-8 gap-y-3">
    <template v-for="voorwaarde in props.voorwaarden" :key="voorwaarde.fileId">
      <div class="font-medium text-grey-900">{{ voorwaarde.omschrijving }}</div>
      <a
        class="flex items-center gap-2 text-primary-500 hover:text-primary-700 hover:underline"
        :href="`/net/documents/GetCondition?fileID=${voorwaarde.fileId}`"
        rel="noopener noreferrer"
        target="_blank"
      >
        <FontAwesomeIcon icon="far fa-file-pdf" class="text-red-600" />

        {{ voorwaarde.titel }}
      </a>
    </template>
  </div>
</template>
